var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '../../utils/cn';
import { ImageEntityBackground } from './image-entity-background';
import { first } from 'lodash';
import { useLogo } from '../../hooks/use-logo';
import { useLink } from '../../hooks/use-link';
import { MarkdownContent } from '../elements/markdown-content';
import { coalesce } from '../../utils/coalesce';
import { LinkButton } from '../elements/link-button';
;
import { Button } from '../elements/button';
;
var cls = classNames('page-holding-layout');
export var PageHoldingLayoutDefaultProps = {
  overlayColor: '#00000088',
  contactLabel: 'Contact Us To Find Out More'
}; // -------- Child Component Props -------->
// -------- Styles -------->

var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 100vh;\n    font-size: ", ";\n    color: ", ";\n    font-weight: 300;\n    b, strong {\n      color: ", ";\n      font-weight: 500;\n    }\n\n    h1 {\n      ", ";\n      margin-bottom: 0.75em;\n      padding-bottom: 0.75em;\n      font-size: 1.45em;\n      text-transform: uppercase;\n      color: ", ";\n      font-weight: 500;\n\n    }\n  "], ["\n    height: 100vh;\n    font-size: ", ";\n    color: ", ";\n    font-weight: 300;\n    b, strong {\n      color: ", ";\n      font-weight: 500;\n    }\n\n    h1 {\n      ", ";\n      margin-bottom: 0.75em;\n      padding-bottom: 0.75em;\n      font-size: 1.45em;\n      text-transform: uppercase;\n      color: ", ";\n      font-weight: 500;\n\n    }\n  "])), theme.FONT_SIZE(16), theme.COLOR('light'), theme.COLOR('light'), theme.H_DOT_BG_END('link-hover'), theme.COLOR('link-hover')),
  tablet: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(18)),
  desktop: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme.FONT_SIZE(22))
});
var TitleStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LayoutStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: relative;\n\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n\n  "], ["\n    position: relative;\n\n    height: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n\n  "])))
});
var ContentStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ButtonStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    width: auto;\n    align-self: flex-start;\n    margin-top: 1.5em;\n    ", " {\n      border-color: ", ";\n      color: ", ";\n      ", ";\n\n      &:hover {\n        color: ", ";\n        ", ";\n      }\n    }\n  "], ["\n    width: auto;\n    align-self: flex-start;\n    margin-top: 1.5em;\n    ", " {\n      border-color: ", ";\n      color: ", ";\n      ", ";\n\n      &:hover {\n        color: ", ";\n        ", ";\n      }\n    }\n  "])), Button.cls.rule(), theme.COLOR('link-hover'), theme.COLOR('light'), theme.FILL('light'), theme.COLOR('link-hover'), theme.FILL('link-hover'))
});
var BodyStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    padding: ", ";\n    max-width: 800px;\n  "], ["\n    display: flex;\n    flex-direction: column;\n    padding: ", ";\n    max-width: 800px;\n  "])), theme.UNIT(8))
});
var LogoContainerStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    position: absolute;\n    left: ", ";\n    top: ", ";\n  "], ["\n    position: absolute;\n    left: ", ";\n    top: ", ";\n  "])), theme.UNIT(4), theme.UNIT(4)),
  tablet: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    left: ", ";\n    top: ", ";\n  "], ["\n    left: ", ";\n    top: ", ";\n  "])), theme.UNIT(6), theme.UNIT(6)),
  desktop: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    left: ", ";\n    top: ", ";\n  "], ["\n    left: ", ";\n    top: ", ";\n  "])), theme.UNIT(8), theme.UNIT(8))
}); // -------- Components -------->

var My = {
  Container: styled(ImageEntityBackground)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Layout: styled.div.attrs(cls.attr('layout'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), LayoutStyles),
  LogoContainer: styled.div.attrs(cls.attr('logo-container'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), LogoContainerStyles),
  Body: styled.div.attrs(cls.attr('body'))(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Title: styled.h1.attrs(cls.attr('title'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), TitleStyles),
  Button: styled(LinkButton)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  Content: styled(MarkdownContent)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), ContentStyles)
};
export var PageHoldingLayout = function PageHoldingLayout(props) {
  var className = props.className,
      children = props.children,
      overlayColor = props.overlayColor,
      entity = props.entity,
      logo = props.logo,
      contactUrl = props.contactUrl,
      contactLabel = props.contactLabel;

  if (!entity) {
    return null;
  }

  var _a = entity.banners,
      banners = _a === void 0 ? [] : _a,
      _b = entity.imageAssets,
      imageAssets = _b === void 0 ? [] : _b,
      title = entity.title,
      intro = entity.intro,
      content = entity.content;
  var text = coalesce(entity, ['intro.text', 'summary.text', 'content.text']);
  var banner = banners.length && first(banners);
  var imageAsset = imageAssets.length && first(imageAssets);
  var Link = useLink().Link;
  var Logo = useLogo();

  if (!banner && !imageAsset) {
    // TODO, make this work without an image?
    return null;
  }

  return React.createElement(My.Container, {
    entity: banner || imageAsset,
    overlayColor: overlayColor,
    className: cls.name(className)
  }, React.createElement(My.Layout, null, (logo || Logo) && React.createElement(My.LogoContainer, {
    className: cls.sub('logo-container')
  }, logo || React.createElement(Logo, null)), React.createElement(My.Body, {
    className: cls.sub('body')
  }, title && React.createElement(My.Title, null, title), React.createElement(My.Content, {
    text: text,
    className: cls.sub('content')
  }), contactUrl && React.createElement(My.Button, {
    href: contactUrl
  }, contactLabel), children)));
};
PageHoldingLayout.cls = cls;
PageHoldingLayout.defaultProps = PageHoldingLayoutDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;